<template>
  <v-dialog
    v-model="show"
    max-width="420"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card class="recover-card pa-6 rounded-xl" dark>
        <!-- Header -->
        <div class="text-center mb-4">
          <v-icon large color="#1976d2">mdi-lock-reset</v-icon>
          <h3 class="mt-2 font-weight-bold">Recuperar contraseña</h3>
          <div class="subtitle-2 mt-1">
            Te enviaremos una nueva contraseña por email
          </div>
        </div>

        <!-- Info -->
        <v-alert dense text color="#1976d2" class="mb-4">
          El email debe coincidir con el registrado al contratar el servicio.
        </v-alert>

        <!-- Usuario -->
        <v-text-field
          v-model="usuario"
          prepend-inner-icon="mdi-account"
          label="Usuario"
          outlined
          dense
          required
          :rules="requiredRules"
          maxlength="30"
        />

        <!-- Email -->
        <v-text-field
          v-model="mail"
          prepend-inner-icon="mdi-email"
          label="E-mail"
          outlined
          dense
          required
          :rules="emailRules"
          maxlength="80"
        />

        <!-- Actions -->
        <v-card-actions class="px-0 pt-4">
          <v-btn
            block
            large
            color="#1976d2"
            :disabled="!valid"
            @click.stop="send"
          >
            Enviar email
          </v-btn>
        </v-card-actions>

        <v-btn
          text
          small
          block
          color="grey lighten-2"
          class="mt-2"
          @click.stop="show = false"
        >
          Volver al login
        </v-btn>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "@/axios-auth.ts";
export default {
  data: (vm) => ({
    horaTurno: null,
    usuario: null,
    mail: null,
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    emailRules: [
      (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido",
      (v) => !!v || "Dato obligatorio",
    ],
    passwordRules: [
      (v) => (v && v.length > 5) || "Mínimo 6 caracteres",
      (v) => !!v || "Dato obligatorio",
    ],
  }),
  props: ["visible"],

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    send() {
      this.$swal({
        title: "Enviar email de recupero de contraseña",
        text: "¿Desea enviar un correo para restaurar su contraseña?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosUsuario = {
            usuario: this.usuario,
            email: this.mail,
          };

          let self = this;
          axios
            .get("/Login/RecuperarPass?", {
              params: {
                usuario: datosUsuario.usuario,
                mail: datosUsuario.email,
              },
            })
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "error",
                  title:
                    "No existe ningún usuario registrado con esos datos. Revise el usuario y el email ingresados por favor.",
                  vm: self,
                });
              } else {
                self.showAlert({
                  icon: "success",
                  title:
                    "Se envió un mail a la casilla de correo registrada con su nueva contraseña. Revise por favor su correo no deseado o spam.",
                  vm: self,
                });
                this.show = false;
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title:
                  "El correo no pudo ser enviado. Intente mas tarde por favor.",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },

    vaciarModels() {
      this.mail = "";
      this.usuario = "";
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 4200,
      });
    },
  },

  created() {
    this.vaciarModels();
  },
};
</script>
<style scoped>
.recover-card {
  backdrop-filter: blur(10px);
  background: rgba(20, 35, 45, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
}
</style>
